import Detection from '../../components/elementDetection';
import { useAppSelector } from '../../store/store';
import PermissionIssue from "../../components/permissionIssue";
import { LinearProgress } from '@mui/material';
import DetectionComponent from '../../components/detectionComponent';

const DetectionPage = () => {
    const { userData } = useAppSelector((state) => state.authReducer);

    if (!userData) {
        return <LinearProgress color="secondary" />;
    }

    const permissions = JSON.parse(userData.permission ?? "[]");
    const hasDetectionAccess = 
        userData.group === "admin" || 
        permissions.includes("39");

    return hasDetectionAccess ? <DetectionComponent /> : <PermissionIssue />;
};

export default DetectionPage;